<template>
  <div class="panel granary-right-panel">
    <div class="xq-box">
      <div class="yzc-box">
        <img src="~images/granary/xmy/yzc-icon.png" alt="" class="icon-xmy" />
        <div class="txt-box">
          <div class="name">{{ xqList[0].name }}</div>
          <div class="total yzc-total">{{ xqList[0].total }}</div>
          <div class="year">
            较2020<span class="add-txt">{{ xqList[0].add }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="yjc-box">
      <div class="yjc-item">
        <div class="txt-box ync-txt">
          <div class="name">{{ xqList[1].name }}</div>
          <div class="total ync-total">{{ xqList[1].total }}</div>
          <div class="year">
            较2020<span class="add-txt">{{ xqList[1].add }}</span>
          </div>
        </div>
        <img src="~images/granary/xmy/ync-icon.png" alt="" class="icon-xmy" />
      </div>
      <div class="yjc-item">
        <img src="~images/granary/xmy/yjc-icon.png" alt="" class="icon-xmy" />
        <div class="txt-box">
          <div class="name">{{ xqList[2].name }}</div>
          <div class="total yjc-total">{{ xqList[2].total }}</div>
          <div class="year">
            较2020
            <span class="add-txt">{{ xqList[2].add }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findIndexByName } from "@/util/index";
import { get } from "@/api/index";
export default {
  data() {
    return {
      xqList: [
        {
          name: "种猪场",
          total: 136,
          add: 6
        },
        {
          name: "种牛场",
          total: 124,
          add: 2
        },
        {
          name: "种鸡场",
          total: 96,
          add: 0
        }
      ],
      ztList: [
        {
          name: "农业龙头企业",
          icon: require("@/assets/images/granary/zzy/jyzt-icon1.png"),
          num: 136,
          unit: "家"
        },
        {
          name: "合作社",
          icon: require("@/assets/images/granary/zzy/jyzt-icon2.png"),
          num: 82,
          unit: "家"
        },
        {
          name: "家庭农场",
          icon: require("@/assets/images/granary/zzy/jyzt-icon3.png"),
          num: 66,
          unit: "家"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      get("/api/dp/visual/queryList?code=xqcqk").then(res => {
        const { item, data } = res;
        if (Array.isArray(data) && data.length > 0) {
          const _dt = data[0];
          this.xqList.forEach(e => {
            const index = findIndexByName(e.name, item, "name");
            if (~index) {
              const code = item[index].code;
              e.total = _dt[code];
            }
            const index1 = findIndexByName(e.name + "较2020", item, "name");
            if (~index1) {
              const code = item[index1].code;
              e.add = _dt[code];
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel
  // height calc(28% - 8px)
  height calc(35% - 8px)
  font-size 0.06rem


.xq-box
  display flex
  justify-content center
  flex-wrap wrap
  padding-top 20px
  .yzc-box
    display flex
    .icon-xmy
      width 100px
      margin-left 90px
      margin-bottom -30px

.yjc-box
  display flex
  justify-content center
  .yjc-item
    display flex
    margin-left 10px
    .icon-xmy
      width 100px
.txt-box
  margin-left 14px
  padding-top 28px
  .name
    font-size 14px
  .total
    margin 2px 0
    font-size 20px
    font-family 'electronicFont'
.add-txt
  color #e9494d !important
.ync-txt
  margin-right 14px
.ync-total
  color #00e2fb
.yzc-total
  color rgb(0, 174, 255)
.yjc-total
  color #ffdc4e
</style>
